module.exports = __webpack_public_path__ + "static/slide4-reimagine-8c4139e51c2d65c138cdc1e3d898ab7f.jpg";